export default __webpack_public_path__ + "static/yandex-presentation-62397584e050c8079e5abbc07fbd3d1a.png";